import {flatCategories,} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category'

export const categoryMethods = {
    flatCategories,
    imageHandler(category, alternativeImage) {
        if (category.image === null) {
            return alternativeImage;
        }
        return category.image
    },
    setLinkType(category, linkType) {
        return linkType === 'blog'
            ?
            {name: 'Posts', query: {category: category.slug}}
            :
            {name: 'SingleCategory', params: {slug: category.slug}}
    },
    clearRouter(linkType) {
        if (linkType == 'blog') {
            return {name: 'Posts'}
        } else {
            return {name: 'SingleCategory'}
        }
    },
    categoryShape(categories) {
        if (this.flatCategoriesShape) {
            return this.flatCategories(categories)
        }
        return categories
    },
}
